export const METRICS = Object.freeze({
  req: {
    name: 'Requests',
    money: false,
  },
  bid: {
    name: 'Bids',
    money: false,
  },
  winrate: {
    name: 'Win Rate',
    money: false,
    percentage: true,
  },
  imp: {
    name: 'Impressions',
    money: false,
  },
  clk: {
    name: 'Clicks',
    money: false,
  },
  ctr: {
    name: 'CTR',
    money: false,
    percentage: true,
  },
  cost: {
    name: 'Cost',
    money: true,
    hidden: true,
  },
  revenue: {
    name: 'Revenue',
    money: true,
  },
  cpm: {
    name: 'CPM',
    money: true,
  },
  win: {
    name: 'Wins',
    money: false,
    hidden: true,
  },
  wincost: {
    name: 'Win cost',
    money: true,
    hidden: true,
  },
})

export const NO_BID_REASONS = Object.freeze({
  Bid: 'Bid Placed',
  BidPriceZero: 'Zero Bid Price',
  BidFloorTooHigh: 'Below Bid Floor',
  FundsUnavailable: 'Budget Exhausted',
  NoBannerAdForSize: 'Banner Size Mismatch',
  NoBannersForImpression: 'No Banner for Impression',
  NoVideoForMime: 'Video MIME Mismatch',
  InvalidMediaFormatTarget: 'Media Format Mismatch',
  MediaFormatNotAllowed: 'Media Target Excluded',
  VideoTargetNotAllowed: 'Video Target Blocked',
  GeoNotIncluded: 'Geo Not Targeted',
  GeoExcluded: 'Geo Excluded',
  GeoNotPrecise: 'Imprecise Geo Data',
  NotInPolygon: 'Outside Polygon',
  NotInRadius: 'Outside Radius',
  GeoCohort: 'Geo Cohort Mismatch',
  GeoCohortFreqCap: 'Geo Cohort Frequency Cap',
  PostalCodePopulationDensity: 'Population Density Filter',
  DeviceNotAllowed: 'Device Excluded',
  OSNotAllowed: 'OS Excluded',
  BrowserNotAllowed: 'Browser Excluded',
  InvalidConnectionType: 'Connection Type Excluded',
  InvalidUserConnectionType: 'User Connection Excluded',
  EmptyIP: 'Missing IP',
  InvalidIP: 'Invalid IP',
  CampBlockedIP: 'IP Blocked',
  CampExcludedIP: 'IP Excluded',
  GenderNotAllowed: 'Gender Excluded',
  AgeNotInRange: 'Age Out of Range',
  NilUser: 'Missing User ID',
  NilUserSegment: 'Missing User Segment',
  ExcludeUserSeg: 'User Segment Excluded',
  IncludeUserSeg: 'User Segment Not Targeted',
  NotInUserList: 'User Not on Approved List',
  InExcludedUserList: 'User Blocklisted',
  CategoryIrrelevant: 'Category Mismatch',
  BlockedAdvertiser: 'Advertiser Blocked',
  BlockedCategory: 'Category Blocked',
  ExcludedIASBrandSafety: 'IAS Brand Safety Fail',
  ExcludedIASBrandSafetyUnrateability: 'IAS Unrateable',
  ExcludedIASViewability: 'IAS Viewability Fail',
  ExcludedIASSuspiciousActivity: 'IAS Suspicious Activity',
  NoAdvertiserTracking: 'No Tracking Available',
  NotInNetworkList: 'Exchange Excluded',
  NotInWhitelist: 'Domain Not on Approved List',
  InBlocklist: 'Domain Blocklisted',
  NotInOrgWhitelist: 'Organization Not on Approved List',
  NotInUrlWhitelist: 'URL Not on Approved List',
  FreqCapOffer: 'Offer Frequency Cap',
  FreqCapMediabuy: 'Media Buy Frequency Cap',
  RetargetingNilUser: 'Retarget: No User ID',
  RetargetingExcludedByOfferStats: 'Retarget: Offer Excluded',
  RetargetingExcludedByMBStats: 'Retarget: Media Buy Excluded',
  RetargetingNotIncludedByOfferStats: 'Retarget: Not in Offer',
  RetargetingNotIncludedByMBStats: 'Retarget: Not in Media Buy',
  RetargetingNotIncludedByAnyStats: 'Retarget: No Segment Match',
  AgentOutOfTime: 'Agent Timeout',
  ScoredTooLow: 'Low Bid Score',
  Replaced: 'Outbid',
  DayPartNotAllowed: 'Daypart Excluded',
  SessionDepthNotAllowed: 'Session Depth Exceeded',
  Ended: 'Flight Ended',
  AppMinDownloadsNotAllowed: 'App Downloads Too Low',
  AppMinRatingNotAllowed: 'App Rating Too Low',
  AppStoreCategoryRatingNotAllowed: 'App Category Rating',
  NotInDeals: 'Not in Deal',
  NoRuleMatched: 'No Rule Match',
  DeviceLanguageNotAllowed: 'Device Language Excluded',
  ContentLanguageNotAllowed: 'Content Language Excluded',
  AdPositionNotAllowed: 'Ad Position Excluded',
  BadLinearity: 'Linearity Mismatch',
  FactualNotFound: 'No Factual Data',
  FilteredByTH: 'Target Hash Filtered',
  NotInWeatherList: 'Weather Mismatch',
  WeatherUnavailable: 'No Weather Data',
  ApiFramework: 'API Framework Unsupported',
})

export const NO_BID_GROUPS = Object.freeze({
  'Financial/Budget': [
    'Bid',
    'BidPriceZero',
    'BidFloorTooHigh',
    'FundsUnavailable',
  ],
  'Ad Format/Creative': [
    'NoBannerAdForSize',
    'NoBannersForImpression',
    'NoVideoForMime',
    'InvalidMediaFormatTarget',
    'MediaFormatNotAllowed',
    'VideoTargetNotAllowed',
  ],
  'Geographic Targeting': [
    'GeoNotIncluded',
    'GeoExcluded',
    'GeoNotPrecise',
    'NotInPolygon',
    'NotInRadius',
    'GeoCohort',
    'GeoCohortFreqCap',
    'PostalCodePopulationDensity',
  ],
  'Device/Connection/IP': [
    'DeviceNotAllowed',
    'OSNotAllowed',
    'BrowserNotAllowed',
    'InvalidConnectionType',
    'InvalidUserConnectionType',
    'EmptyIP',
    'InvalidIP',
    'CampBlockedIP',
    'CampExcludedIP',
  ],
  'User/Demographics/Segments': [
    'GenderNotAllowed',
    'AgeNotInRange',
    'NilUser',
    'NilUserSegment',
    'ExcludeUserSeg',
    'IncludeUserSeg',
    'NotInUserList',
    'InExcludedUserList',
  ],
  'Content/Brand Safety': [
    'CategoryIrrelevant',
    'BlockedAdvertiser',
    'BlockedCategory',
    'ExcludedIASBrandSafety',
    'ExcludedIASBrandSafetyUnrateability',
    'ExcludedIASViewability',
    'ExcludedIASSuspiciousActivity',
    'NoAdvertiserTracking',
  ],
  'Domain/Network Whitelisting': [
    'NotInNetworkList',
    'NotInWhitelist',
    'InBlocklist',
    'NotInOrgWhitelist',
    'NotInUrlWhitelist',
  ],
  'Frequency Capping': [
    'FreqCapOffer',
    'FreqCapMediabuy',
  ],
  'Retargeting': [
    'RetargetingNilUser',
    'RetargetingExcludedByOfferStats',
    'RetargetingExcludedByMBStats',
    'RetargetingNotIncludedByOfferStats',
    'RetargetingNotIncludedByMBStats',
    'RetargetingNotIncludedByAnyStats',
  ],
  'Auction/Timing Logic': [
    'AgentOutOfTime',
    'ScoredTooLow',
    'Replaced',
  ],
  'Scheduling': [
    'DayPartNotAllowed',
    'SessionDepthNotAllowed',
    'Ended',
  ],
  'App Store Targeting': [
    'AppMinDownloadsNotAllowed',
    'AppMinRatingNotAllowed',
    'AppStoreCategoryRatingNotAllowed',
  ],
  'Other/Miscellaneous': [
    'NotInDeals',
    'NoRuleMatched',
    'DeviceLanguageNotAllowed',
    'ContentLanguageNotAllowed',
    'AdPositionNotAllowed',
    'BadLinearity',
    'FactualNotFound',
    'FilteredByTH',
    'NotInWeatherList',
    'WeatherUnavailable',
    'ApiFramework',
  ],
})

export const FILTER_LABELS = Object.freeze({
  DomainReq: 'Domain request received and processed',
  DomainIDZero: 'Domain lookup returned no ID (unknown domain)',
  PublisherBlock: 'Publisher is blocked or not recognized',
  EnrichTimeout: 'Request enrichment (geo, browser, OS) exceeded timeout',
  'US-Filter': 'US geographic filter - invalid ad sizes for US traffic',
  'OldBrowser-Filter': 'Outdated browser detected (IE, old Safari, etc.)',
  'IAB-Filter': 'Content category is blocked (IAB2-5, IAB2-6 categories)',
  NoAgentAvailable: 'No agent servers available for bidding',
  NoAgentQualified: 'No agents qualified for this request (hash/geo targeting)',
  'NoAgentResp(timeout)': 'Agents took too long to respond (timeout exceeded)',
  'NoAgentResp(finish)': 'All agents responded but no bid was generated',
  DomainBid: 'Successful bid placed (winning domain)',
})
